import { CircularProgress } from "@mui/material";
import { Backdrop } from "@mui/material";
import { RootState } from "../store/store";
import { useAppSelector } from "../store/customHooks";

export default function Loader(props: any) {
  const loader = useAppSelector((state: RootState) => state.common.isLoader);
  return (
    <div>
      {loader.isLoader == true && (
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Backdrop open={true} style={{ color: "#fff", zIndex: 1 }}>
            <CircularProgress
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              size={30}
            />
          </Backdrop>
        </div>
      )}
    </div>
  );
}
